import { createStyles, makeStyles, Theme } from '@material-ui/core';
import Header from './components/Header/Header';
import { MainContent } from './components/MainContent/MainContent';
import { Logo } from './icons/Logo';
import { useAppStateContext } from './components/AppStateProvider/AppStateProvider';
import { useEffect } from 'react';
import { LIVEKIT_CLOUD, LIVEKIT_SELFHOSTED, TWILIO } from './constants';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appContainer: {
      position: 'relative',
      width: `calc(100% - ${theme.brandSidebarWidth}px)`,
      height: '100%',
      background: theme.backgroundColor,
      overflow: 'hidden',
      [theme.breakpoints.between('md', 1280)]: {
        width: `calc(100% - ${theme.tabletBrandSidebarWidth}px)`,
      },
      [theme.breakpoints.down('sm') + theme.includeLandscapeMd]: {
        width: '100%',
        overflowY: 'auto',
      },
    },
    brandSidebar: {
      background: '#06033A',
      position: 'fixed',
      top: 0,
      bottom: 0,
      right: 0,
      left: `calc(100% - ${theme.brandSidebarWidth}px)`,
      '& svg': {
        position: 'absolute',
        right: 0,
        bottom: 40,
      },
      [theme.breakpoints.between('md', 1280)]: {
        left: `calc(100% - ${theme.tabletBrandSidebarWidth}px)`,
      },
      [theme.breakpoints.down('sm') + theme.includeLandscapeMd]: {
        display: 'none',
      },
    },
  })
);
const providers = [
  { id: 'Twilio', label: TWILIO },
  { id: 'Livekit Cloud', label: LIVEKIT_CLOUD },
  { id: 'Livekit Self-Hosted', label: LIVEKIT_SELFHOSTED },
];
function App() {
  const classes = useStyles();
  const { dispatch } = useAppStateContext();
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const providerFromParams = params.get('provider');
    const validProvider = providers.find((provider) => provider.label === providerFromParams);

    if (validProvider) {
      dispatch({ type: 'select-provider', selectedProvider: validProvider.label });
    }
  }, [dispatch]);
  return (
    <div className={classes.appContainer}>
      <Header />
      <MainContent />
      <div className={classes.brandSidebar}>
        <Logo />
      </div>
    </div>
  );
}

export default App;
